@if (!!appService.selectedClient) {
<!-- Client existant -->
<div class="h-full overflow-y-auto p-3">
    <div class="grid">
        <div class="col-12 xl:col-8 xl:col-offset-2 txl:col-6 txl:col-offset-3">
            <div class="mb-3">
                <p-fieldset legend="Données générales">
                    <app-client-form></app-client-form>
                </p-fieldset>
            </div>
            @if (appService.user?.hasAuthorization(Authorizations.AddressRead)) {
            <div class="mb-3">
                <p-fieldset legend="Adresse">
                    <app-address-form [address]="appService.selectedClient.address"></app-address-form>
                </p-fieldset>
            </div>
            }
            @if (appService.user?.hasAuthorization(Authorizations.ClientUpdate)) {
            <div class="mb-3">
                <p-fieldset>
                    <ng-template #header>
                        <div class="flex align-items-center gap-1">
                            <span class="font-bold">Double authentification</span>
                            <app-mfa-info></app-mfa-info>
                        </div>
                    </ng-template>
                    <app-client-mfa-form></app-client-mfa-form>
                </p-fieldset>
            </div>
            }
            @if (appService.user?.hasAuthorization(Authorizations.ClientDelete)) {
            <div class="mb-3">
                <p-fieldset legend="Zone rouge" [dt]="dangerFieldset">
                    <app-danger-zone-form></app-danger-zone-form>
                </p-fieldset>
            </div>
            }
        </div>
    </div>
</div>

} @else {

<!-- Création d'un nouveau client -->
<div class="h-full w-full">
    <app-create-client-form (created)="onClientCreated($event)"></app-create-client-form>
</div>

}
